import { render, staticRenderFns } from "./WalletCards.vue?vue&type=template&id=16bfc95e&scoped=true&"
import script from "./WalletCards.vue?vue&type=script&lang=js&"
export * from "./WalletCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bfc95e",
  null
  
)

export default component.exports